import type { ReactElement } from 'react';
import './catalog.css';
import { Categories } from './Categories.tsx';
import { Import } from './Import.tsx';
import { Markets } from './Markets.tsx';
import { GLOBAL_MERCHANTS_PATH } from './MerchantTabs.tsx';
import { MasterMerchants } from './MasterMerchants.tsx';

export { MerchantCatalogPanels } from './MerchantPanels.tsx';
export { AddMerchantButton, MerchantBulkBar, MerchantTabs } from './MerchantTabs.tsx';
export { CouponBulkBar, CouponMoreActions } from './CouponActions.tsx';

export const CATALOG_SHORTCUTS: [string, string][] = [
  ['g then y / w / i', 'Go to Categories, Markets, Import'],
  ['n', 'New item on Markets, Categories, Global merchants'],
  ['x', 'Merchants, Coupons: select row for a bulk action'],
];

export function catalogPage(path: string): ReactElement | null {
  if (path === '/markets') return <Markets />;
  if (path === GLOBAL_MERCHANTS_PATH) return <MasterMerchants />;
  if (path === '/categories') return <Categories />;
  if (path === '/import') return <Import />;
  return null;
}
